// Beyoncé Songs - Ranked by Chart Performance & Popularity
// Difficulty: DIFFICULT - Music chart knowledge required

export const beyonceSongsData = [
  { id: 1, name: "Crazy in\nLove", rank: 1, image: "/images/beyonce/crazy_in_love.png" },
  { id: 2, name: "Single\nLadies", rank: 2, image: "/images/beyonce/single_ladies.png" },
  { id: 3, name: "Halo", rank: 3, image: "/images/beyonce/halo.png" },
  { id: 4, name: "Irreplaceable", rank: 4, image: "/images/beyonce/irreplaceable.png" },
  { id: 5, name: "If I Were\na Boy", rank: 5, image: "/images/beyonce/if_i_were_a_boy.png" },
  { id: 6, name: "Love on\nTop", rank: 6, image: "/images/beyonce/love_on_top.png" },
  { id: 7, name: "Drunk in\nLove", rank: 7, image: "/images/beyonce/drunk_in_love.png" },
  { id: 8, name: "Formation", rank: 8, image: "/images/beyonce/formation.png" },
  { id: 9, name: "Run the\nWorld", rank: 9, image: "/images/beyonce/run_the_world.png" },
  { id: 10, name: "Déjà Vu", rank: 10, image: "/images/beyonce/deja_vu.png" },
  { id: 11, name: "Beautiful\nLiar", rank: 11, image: "/images/beyonce/beautiful_liar.png" },
  { id: 12, name: "Partition", rank: 12, image: "/images/beyonce/partition.png" },
  { id: 13, name: "XO", rank: 13, image: "/images/beyonce/xo.png" },
  { id: 14, name: "Texas\nHold 'Em", rank: 14, image: "/images/beyonce/texas_hold_em.png" },
  { id: 15, name: "Sorry", rank: 15, image: "/images/beyonce/sorry.png" },
  { id: 16, name: "Check on\nIt", rank: 16, image: "/images/beyonce/check_on_it.png" },
  { id: 17, name: "Listen", rank: 17, image: "/images/beyonce/listen.png" },
  { id: 18, name: "Sweet\nDreams", rank: 18, image: "/images/beyonce/sweet_dreams.png" },
  { id: 19, name: "Baby Boy", rank: 19, image: "/images/beyonce/baby_boy.png" },
  { id: 20, name: "Diva", rank: 20, image: "/images/beyonce/diva.png" },
  { id: 21, name: "Me, Myself\nand I", rank: 21, image: "/images/beyonce/me_myself_and_i.png" },
  { id: 22, name: "Naughty\nGirl", rank: 22, image: "/images/beyonce/naughty_girl.png" },
  { id: 23, name: "End of\nTime", rank: 23, image: "/images/beyonce/end_of_time.png" },
  { id: 24, name: "Best Thing\nI Never\nHad", rank: 24, image: "/images/beyonce/best_thing_i_never_had.png" },
  { id: 25, name: "Flawless", rank: 25, image: "/images/beyonce/flawless.png" },
  { id: 26, name: "Countdown", rank: 26, image: "/images/beyonce/countdown.png" },
  { id: 27, name: "Pretty\nHurts", rank: 27, image: "/images/beyonce/pretty_hurts.png" },
  { id: 28, name: "Spirit", rank: 28, image: "/images/beyonce/spirit.png" },
  { id: 29, name: "Upgrade U", rank: 29, image: "/images/beyonce/upgrade_u.png" },
  { id: 30, name: "Blow", rank: 30, image: "/images/beyonce/blow.png" },
];
